import { LocaleStrings } from './i18n';

const lt: LocaleStrings = {
    // ---------------BILLING---------------
    assign_child: 'Priskirti vaiką',
    assign_child_warning: 'Galite priskirti vaiką tik vieną kartą. Vėliau to negalėsite pakeisti.',
    assign_child_success: 'Vaikas sėkmingai priskirtas planui',
    assign_child_failure: 'Vaiko nepavyko priskirti planui',
    cancel_plan: 'Atšaukti Planą',
    manage_plan: 'Valdyti Planą',
    month: 'Mėnesis',
    your_enrollments: 'Planas',
    login_success: 'Prisijungta sėkmingai',
    // ---------------PASSWORD RESET---------------
    password_reset_code_verified: 'Slaptažodžio nustatymo iš naujo kodas patvirtintas',
    password_reset_success: 'Slaptažodis sėkmingai nustatytas iš naujo',
    password_update_success: 'Slaptažodis sėkmingai atnaujintas',
    register_success: 'Užsiregistravote sėkmingai',
    user_update_success: 'Vartotojo profilis sėkmingai atnaujintas',
    all: 'Visos',
    allowed: 'Leidžiama',
    already_have_account: 'Jau turite paskyrą?',
    and: 'ir',
    back: 'atgal',
    by_registering_agree: 'Registruodamiesi patvirtiname, kad sutinkate su CodeAcademy Kids',
    change_password: 'keisti slaptažodį',
    code: 'Kodas',
    code_required: 'Kodas yra privalomas',
    confirm_new_password: 'Patvirtinkite naują slaptažodį',
    content: 'Turinys',
    dashboard: 'Pagrindinis',
    didnt_receive_email: 'Negavote el. laiško?',
    dont_have_account: `Neturite paskyros?`,
    email_address: 'El. pašto adresas',
    email_address_must_be_from_codeacademy_domain: 'Turi būti galiojantis CodeAcademy el. pašto adresas',
    email_address_must_be_valid: 'El. pašto adresas turi būti validus',
    email_address_required: 'El. pašto adresas yra privalomas',
    email_address_must_be_different_than_yours: 'El. pašto adresas turi būti skirtingas nei jūsų',
    enter_new_password_subtitle: 'Įveskite naują slaptažodį, kuris bus susietas su jūsų paskyra.',
    enter_new_password_title: 'Įveskite naują slaptažodį',
    error_fetching_lessons: 'Gaunant pamokas įvyko klaida.',
    error_fetching_modules: 'Gaunant modulius įvyko klaida',
    error_fetching_topic_content: 'Gaunant temos turinį įvyko klaida',
    error_fetching_topics: 'Gaunant temą įvyko klaida',
    finish: 'Užbaigti pamoką',
    first_name: 'Vardas',
    first_name_required: 'Vardas yra privalomas',
    forgot_password: 'Pamiršote slaptažodį',
    forgot_your_password_details:
        'Įveskite su paskyra susietą el. pašto adresą ir el. paštu atsiųsime nuorodą slaptažodžiui nustatyti iš naujo.',
    forgot_your_password_title: 'Pamiršote slaptažodį?',
    general: 'bendri',
    go_to_home: 'Grįžti į pagrindinį',
    group: 'Grupė',
    group_content: 'Grupės turinys',
    groups: 'Grupės',
    groups_content: 'grupės turinį',
    groups_content_updates: 'Grupės turinys atnaujintas',
    home: 'Pagrindinis',
    incorrect_or_tampered_link: 'Neteisinga arba sugadinta nuoroda',
    internal_server_error: 'Vidinė serverio klaida',
    internal_server_error_description:
        'Įvyko klaida. Bandykite dar kartą vėliau arba susisiekite su sistemos administratoriumi.',
    last_name: 'Pavardė',
    last_name_required: 'Pavardė yra privaloma',
    latest: 'Naujausia',
    lesson: 'Pamoka',
    lessons: 'Pamokos',
    link_to_login_text: 'Prisijungti',
    link_to_registration_text: 'Užsiregistruokite',
    login: `Prisijungti`,
    login_form_subtitle: `Įveskite savo prisijungimo duomenis žemiau.`,
    login_form_title: 'Prisijunkite prie CodeAcademy Kids',
    login_greeting_title: `Sveiki sugrįžę!`,
    login_illustration: 'prisijungimo iliustracija',
    login_with_google: `Prisijungti su Google`,
    logout: `Atsijungti`,
    module_code: 'Modulio kodas',
    module_illustration: 'modulio iliustracija',
    modules: 'Moduliai',
    name: 'Pavadinimas',
    new_password: 'Naujas slaptažodis',
    new_password_helper_text: 'Slaptažodis turi būti bent 8 simbolių',
    new_password_required: 'Reikalingas naujas slaptažodis',
    next: 'Sekanti tema',
    no_lessons_found: 'Nerasta jokių pamokų',
    no_modules_found: 'Kol kas jokių modulių nerasta. Jie atsiras čia, kai mokytojas(-a) juos atidarys.',
    no_results_for: 'Rezultatų nerasta',
    no_results_helper_text: 'Pabandykite patikrinti ar nėra rašybos klaidų, arba naudokite pilnus žodžius.',
    no_topics_found: 'Nerasta jokių temų',
    not_found: 'Rezultatų nerasta',
    notifications: 'pranešimai',
    old_password: 'Senas slaptažodis',
    old_password_required: 'Reikalingas senas slaptažodis',
    unlock_lessons_helper_text: 'Tuščia reikšmė reiškia, kad modulis yra nematomas',
    opened_lessons: 'Atidarytos pamokos',
    page_not_found: 'Puslapis nerastas',
    page_not_found_description: 'Atsiprašome, nepavyko rasti puslapio, kurio ieškote. Galbūt neteisingai įvedėte URL?',
    password: 'Slaptažodis',
    password_must_be_at_least_8_characters: 'Slaptažodis turėtų būti per 8 simbolių',
    password_must_match: 'Slaptažodžiai turi sutapti',
    password_required: 'Slaptažodis yra privalomas',
    please_check_your_email: 'Prašome patikrinti savo el. paštą.',
    please_try_again_or_contact_admin: '',
    privacy_policy: 'Privatumo Politika',
    points: 'taškai',
    redirecting: 'Nukreipiama',
    register: `Registruotis`,
    register_illustration: 'registracijos iliustracija',
    registration_form_subtitle: 'Išskirtinai skirta CodeAcademy Kids klientams.',
    registration_form_title: 'Užsiregistruokite prie CodeAcademy Kids',
    registration_greeting_title: `Internetinė švietimo platforma, skirta padėti mūsų studentams`,
    remember_me: 'Prisiminti mane',
    confirm_email: 'Patvirkinkite savo el. pašto adresą',
    resend_email: 'Iš naujo siųsti el. laišką',
    reset_password: 'Atstatyti slaptažodį',
    reset_password_greeting_title: 'Atstatykite prisijungimą',
    reset_password_illustration: 'slaptažodžio nustatymo iš naujo iliustracija',
    save_changes: 'Išsaugoti pakeitimus',
    please_fill_all_fields: 'Prašome užpildyti visus lankomumo laukelius prieš išsaugant',
    search_groups: 'Ieškoti grupių',
    sent_confirmation_email_to: 'Išsiuntėme patvirtinimo el. laišką adresu',
    confirmation_email_success:
        'Patvirtinimo el. laiškas išsiųstas. Prašome patikrinti ir šlamšto (angl. "spam") dežutę.',
    confirmation_email_failure: 'Nepavyko išsiųsti patvirtinimo el. laiško. Bandykite dar kartą vėliau.',
    set_password: 'Nustatyti slaptažodį',
    something_went_wrong: 'Įvyko klaida.',
    sorted_ascending: 'rūšiuojama didėjančia tvarka',
    sorted_descending: 'rūšiuojama mažėjančia tvarka',
    terms_of_service: 'Paslaugų Teikimo Sąlygomis',
    too_long: 'Per ilgas!',
    too_short: 'Per trumpas!',
    topic: 'Tema',
    topics: 'Temos',
    unable_to_logout: `Nepavyko atsijungti!`,
    update_photo: 'Atnaujinti nuotrauką photo',
    upload_photo: 'Įkelti nuotrauką',
    user: 'Vartotojas',
    user_management: 'Vartotojo valdymas',
    verify: 'Patvirtinti',
    verify_code_subtitle: 'Įveskite 6 simbolių patvirtinimo kodą. Jeigu kodo neturite, kreipkitės į administraciją.',
    verify_code_title: 'Įveskite patvirtinimo kodą',
    verify_email_and_code_illustration: 'patvirtinkite el. pašto adresą ir kodo iliustracija',
    verify_email_subtitle_part_1: 'Išsiuntėme Jums patvirtinimo nuorodą',
    verify_email_subtitle_part_2: 'spustelėkite šią nuorodą, kad patvirtintumėte savo el. pašto adresą.',
    verify_email_title: 'Patikrinkite savo el. paštą!',
    check_spam_folder: 'Jei nerandate mūsų laiško, patikrinkite savo šlamšto (angl. "spam") dežutę.',
    view_lesson: 'Žiūrėti pamoką',
    view_module: 'Žiūrėti modulį',
    your_account: 'Jūsų paskyra',
    lastest_lesson: 'Naujausia pamoka',
    all_lessons: 'Visos pamokos',
    unlock_lessons: 'atrakinti pamokas',
    settings: 'nustatymai',
    // eslint-disable-next-line max-len
    group_not_assigned: `Jūs dar nesate priskirtas jokiai grupei. Palaukite informacijos iš savo grupės koordinatoriaus arba dėstytojo. Jei turite kitų klausimų, būtinai susisiekite su mumis. Jei esate tėtis/mama, prašome pridėti savo vaiką prie savo paskyros.`,
    // ---------------LANGUAGE SETTINGS---------------
    language: 'kalba',
    language_preference: 'Kalba',
    language_preference_saved: 'Kalbos pasirinkimas išsaugotas',
    language_required: 'Kalbos pasirinkimas yra privalomas',
    // ---------------XXX---------------
    'auth/invalid-verification-code':
        // eslint-disable-next-line max-len
        'Įvestas patvirtinimo kodas yra neteisingas. Patikrinkite kodą ir bandykite dar kartą arba paprašykite naujo kodo, jei reikia.',
    'auth/email-already-in-use':
        // eslint-disable-next-line max-len
        'Jūsų pateiktas el. pašto adresas jau naudojamas esamos paskyros. Prašome prisijungti naudodami tą el. paštą arba pasirinkti kitą, norėdami sukurti naują paskyrą.',
    'auth/expired-action-code':
        'Jūsų naudota nuoroda nebegalioja. Prašome paprašyti naujos nuorodos, kad galėtumėte tęsti.',
    'auth/invalid-action-code':
        'Nuoroda yra neteisinga arba jau buvo panaudota. Prašome paprašyti naujos nuorodos, kad galėtumėte tęsti.',
    'auth/invalid-email': 'Įvestas el. pašto adresas yra neteisingas. Patikrinkite formatą ir bandykite dar kartą.',
    'auth/invalid-user-token': 'Jūsų sesija nebegalioja. Prašome prisijungti iš naujo, kad galėtumėte tęsti.',
    'auth/user-disabled': 'Jūsų paskyra yra užblokuota. Prašome susisiekti su klientų aptarnavimu dėl pagalbos.',
    'auth/user-not-found':
        'Paskyra su pateikta informacija nerasta. Patikrinkite savo duomenis arba užsiregistruokite naujai paskyrai.',
    'auth/user-token-expired': 'Jūsų sesijos laikas pasibaigė. Prašome prisijungti iš naujo, kad galėtumėte tęsti.',
    'auth/weak-password':
        // eslint-disable-next-line max-len
        'Įvestas slaptažodis yra per silpnas. Prašome pasirinkti stipresnį slaptažodį, atitinkantį mūsų saugumo reikalavimus.',
    'auth/wrong-password':
        // eslint-disable-next-line max-len
        'Įvestas el. paštas arba slaptažodis yra neteisingas. Bandykite dar kartą arba atkurkite slaptažodį, jei jį pamiršote.',
    'auth/no-stripe-customer':
        // eslint-disable-next-line max-len
        'Nepavyko rasti kliento, susijusio su Jūsų įvestu el. paštu. Jei esate tėtis, mama arba globėjas, įsitikinkite, kad naudojate tą patį el. pašto adresą, kuriuo gaunate sąskaitas. Jei esi moksleivis, paprašyk savo tėvų arba globėjo tave pakviesti prisijungti prie platformos, jiems reikės nueiti į skiltį Vaikai -> Pridėti naują vaiką.',
    'db/no-document':
        'Nerasta įrašų, atitinkančių jūsų užklausą. Prašome pakeisti paieškos kriterijus ir bandyti dar kartą.',
    last_updated: 'Paskautinį kartą atnaujinta',
    by: '|',
    past_due: 'Neapmokėtas',
    billing: 'Apmokėjimai',
    // ---------------CANCEL PLAN MODAL---------------
    plan_cancellation: 'Plano atšaukimas',
    plan_cancellation_text:
        'Klientų konsultantas susisieks dėl sutarties nutraukimo, atšaukus planą jis bus ištrintas visam laikui',
    cancel_plan_discard: 'Ne, nenoriu atšaukti plano',
    cancel_plan_accept: 'Taip, atšaukti planą',
    tooExpensive: 'Finansinės priežastys',
    notUsingOften: 'Nenaudoju šio plano taip dažnai kaip tikėjausi',
    tooDifficult: 'Per sudėtinga programa',
    didntWorkAsExpected: 'Paslauga / programa neveikia taip, kaip tikėtasi',
    techIssues: 'Per daug techninių problemų',
    changePlan: 'Noriu pasikeisti planą',
    Other: 'Kita',
    other_reason_text_field: 'Kita priežastis',
    reason_required_error: 'Pasirinkite plano atšaukimo priežastį',
    other_reason_required_error: 'Įrašykite plano atšaukimo priežastį',
    request_to_cancel_plan: 'Parašymas atšaukti išsiųstas sėkmingai. Su Jumis netrukus susisieksime!',
    // ---------------GROUP LIST---------------
    group_list: 'Grupių sąrašas',
    create_new_group: 'Sukurti naują grupę',
    new_group: 'Nauja grupė',
    edit_group: 'Redaguoti grupę',
    create_group: 'Sukurti grupę',
    list: 'Sąrašas',
    students: 'Studentai',
    availability: 'Užimtumas',
    active: 'Aktyvios',
    graduated: 'Baigusios',
    inactive: 'Neaktyvios',
    full: 'Pilna',
    available: 'Vietų yra',
    online: 'Internetu',
    live: 'Gyvai',
    search: 'Paieška',
    clear: 'Išvalyti',
    no_data: 'Duomenų nerasta',
    selected: 'Pasirinkta',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    items: 'įrašai',
    are_you_sure_you_want_to_delete: 'Ar tikrai norite ištrinti',
    cancel: 'Atšaukti',
    student_points: 'Studentų taškai',
    // ---------------GROUP FORM---------------
    group_name: 'Grupės pavadinimas',
    group_id: 'Group kodas',
    product: 'Produktas',
    general_info: 'Bendri duomenys',
    teachers: 'Dėstytojai',
    teacher_name: 'Dėstytojo vardas',
    add_teacher: 'Pridėti dėstytoją',
    select_teacher: 'Pasirinkite dėstytoją',
    learning_mode: 'Mokymosi būdas',
    schedule: 'Tvarkaraštis',
    max_students: 'Maksimalus studentų skaičius',
    remove: 'Pašalinti',
    select_student: 'Pasirinkite studentą',
    add_student: 'Pridėti studentą',
    address: 'Adresas',
    city: 'Miestas',
    city_required_error: 'Įveskite miestą',
    address_required_error: 'Įveskite adresą',
    start_date: 'Pradžios data',
    end_date: 'Pabaigos data',
    status: 'Statusas',
    monday: 'Pirmadienis',
    tuesday: 'Antradienis',
    wednesday: 'Trečiadienis',
    thursday: 'Ketvirtadienis',
    friday: 'Penktadienis',
    saturday: 'Šeštadienis',
    sunday: 'Sekmadienis',
    start_time: 'Pradžios laikas',
    end_time: 'Pabaigos laikas',
    repeat_interval: 'Pasikartojimo intervalas',
    once: 'Vieną kartą',
    weekly: 'Kas savaitę',
    biweekly: 'Kas dvi savaites',
    monthly: 'Kas mėnesį',
    bimonthly: 'Kas du mėnesius',
    id_required_error: 'Įveskite grupės kodą',
    name_required_error: 'Įveskite grupės pavadinimą',
    max_students_required_error: 'Įveskite maksimalų studentų skaičių',
    product_required_error: 'Pasirinkite produktą',
    mode_required_error: 'Pasirinkite mokymosi būdą',
    status_required_error: 'Pasirinkite statusą',
    failed_to_create_group: 'Nepavyko sukurti grupės',
    failed_to_update_group: 'Nepavyko atnaujinti grupės',
    successfully_created_group: 'Grupė sėkmingai sukurta',
    successfully_updated_group: 'Grupė sėkmingai atnaujinta',
    failed_to_delete_group: 'Nepavyko ištrinti grupės',
    failed_to_delete_groups: 'Nepavyko ištrinti grupių',
    successfully_deleted_group: 'Grupė sėkmingai ištrinta',
    successfully_deleted_groups: 'Grupės sėkmingai ištrintos',
    confirm_changes: 'Patvirkinkite pakeitimus',
    review_changes_before_updating: 'Peržiūrėkite pakeitimus prieš atnaujinant',
    before: 'Prieš',
    after: 'Po',
    confirm: 'Patvirtinti',
    // ---------------USER FORM---------------
    role_required_error: 'Pasirinkite vartotojo rolę',
    // --------------- ATTENDANCE ---------------
    attendance: 'Lankomumas',
    account: 'Paskyra',
    log_attendance: 'Įrašyti lankomumą',
    student: 'Studentas',
    select_group_student: 'Pasirinkite studentą ir grupę',
    select_group_and_student: 'Pasirinkite grupę ir studentą',
    present: 'Dalyvavo',
    absent: 'Nedalyvavo',
    late: 'Pavėlavo',
    left_early: 'Išėjo anksčiau',
    comment: 'Komentaras',
    group_comment: 'Komentaras grupei',
    student_comment: 'Komentaras studentui',
    is_approved: 'Taškai peržiūrėti ir patvirtinti',
    attendance_percentage: 'Lankomumo procentas',
    select: 'Pasirinkti',
    select_date: 'Pasirinkite datą',
    role: 'Rolė',
    admin: 'Administratorius',
    child: 'Mokinys',
    teacher: 'Dėstytojas',
    parent: 'Tėtis / Mama',
    '': '',
    no_students: 'Studentų nerasta',
    attendance_required: 'Pažymėkite lankomumą',
    comment_min_3_characters: 'Komentaras turi būti bent 3 simboliai',
    successfully_save_daily_sheet: 'Lankomumas ir taškai sėkmingai išsaugoti',
    no_lecture_on_this_date: 'Pasirinktą dieną tvarkaraštyje pamokos nėra. Patikrinkite ar pasirinkote teisingą datą.',
    failed_to_save_daily_sheet: 'Nepavyko išsaugoti lankomumo ir taškų',
    permission_denied: 'Prieiga negalima',
    no_permission_to_access_page: 'Neturite leidimo prieiti prie šio puslapio.',
    feature_not_available: 'Funkcija nepasiekiama',
    feature_disabled_for_group:
        'Ši funkcija šiai grupei neprieinama. Pagal pasirinktą modelį joje siūlomas ribotas funkcijų rinkinys.',
    only_students_can_claim_rewards:
        'Šiuo metu prizus galima užsakyti tik iš vaiko paskyros, atsiprašome už laikinus nepatogumus.',
    select_year: 'Pasirinkite metus',
    today: 'Šiandien',
    no_groups_found: 'Grupių nerasta',
    my_studies: 'Mano studijos',
    contact_sales: 'Susisiekite su mumis ir įsigykite planą',
    via_email: 'el. paštu',
    via_phone: 'telefonu',
    manage_plans: 'Valdykite planus',
    left: 'Liko',
    no_child_selected: 'Pasirinkite vaiką',
    no_records: 'Įrašų nėra',
    assign_to_plan: 'Priskirti planui',
    close: 'Uždaryti',
    child_already_assigned: 'Vaikas jau priskirtas',
    no_child_assigned: 'Vaikas nėra priskirtas',
    or: 'arba',
    no_subscriptions: 'Prenumeratų nėra',
    or_select_existing_child: 'arba priskirkite esamą vaiką',
    already_existing_child: 'Ar norite priskirti esamą vaiką?',
    select_child: 'Pasirinkite',
    dont_have_existing_child: 'Dar nepridėjote vaiko?',
    sent_invitation_mail: 'Pakvietimas išsiųstas el. paštu: ',
    meeting_link_required_error: 'Įveskite susitikimo nuorodą',
    meeting_link: 'Susitikimo nuoroda',
    meeting_links: 'Susitikimų nuorodos',
    comma_separated_links: 'Nuorodos atskirtos kableliais',
    meeting_information: 'Susitikimo failai',
    meeting_recordings_required_error: 'Įveskite pamokų įrašų nuorodą',
    meeting_recordings: 'Pamokų įrašai',
    taken: 'Užimta',
    week: 'Savaitė',
    day: 'Diena',
    monday_meeting_link: 'Monday meeting link',
    tuesday_meeting_link: 'Tuesday meeting link',
    wednesday_meeting_link: 'Wednesday meeting link',
    thursday_meeting_link: 'Thursday meeting link',
    friday_meeting_link: 'Friday meeting link',
    saturday_meeting_link: 'Saturday meeting link',
    sunday_meeting_link: 'Sunday meeting link',
    agenda: 'Darbotvarkė',
    join_zoom_meeting: 'Prisijunkite prie Zoom susitikimo',
    instructions: 'Instrukcijos',
    management: 'Valdymas',
    analytics: 'Analitika',
    max_points_per_student: 'Daugiausia taškų',
    export_csv: 'Eksportuoti CSV',
    // --------------- USERS ---------------
    users: 'Vartotojai',
    new_user: 'Naujas vartotojas',
    create_new_user: 'Sukurti naują vartotoją',
    edit_user: 'Redaguoti vartotoją',
    create_user: 'Sukurti vartotoją',
    parent_id: 'Tevų vartotojo ID',
    parent_id_required_error: 'Įveskite tevų vartotojo ID',
    stripe_id: 'Tevų Stripe ID',
    stripe_id_required_error: 'Įveskite Stripe ID',
    verify_email: 'Patvirtinti el. paštą',
    verified: 'Patvirtinti',
    unverified: 'Nepatvirtinti',
    email_verified: 'El. paštas patvirtintas',
    successfully_verified_email: 'El. paštas sėkmingai patvirtintas',
    failed_to_verify_email: 'Nepavyko patvirtinti el. pašto. Bandykite dar kartą.',
    failed_to_create_user: 'Nepavyko sukurti vartotojo',
    failed_to_update_user: 'Nepavyko atnaujinti vartotojo',
    successfully_created_user: 'Vartotojas sėkmingai sukurtas',
    successfully_updated_user: 'Vartotojas sėkmingai atnaujintas',
    failed_to_delete_user: 'Nepavyko ištrinti vartotojo',
    failed_to_delete_users: 'Nepavyko ištrinti vartotojų',
    successfully_deleted_user: 'Vartotojas sėkmingai ištrintas',
    successfully_deleted_users: 'Vartotojai sėkmingai ištrinti',
    // --------------- CHILDREN ---------------
    children: 'Vaikai',
    new_child: 'Pridėti vaiką',
    edit_child: 'Redaguoti vaiką',
    invited: 'Pakviestas',
    registered: 'Prisiregistravęs',
    resend_invitation: 'Persiųsti pakvietimą',
    invite_child: 'Siųsti pakvietimą',
    invite_new_child: 'Pakviesti naują vaiką',
    add_child: 'Pridėti vaiką',
    birthDate: 'Gimimo data',
    birth_date_required: 'Įveskite gimimo datą',
    must_be_at_least_6_years_old: 'Turi būti bent 6 metų',
    must_be_no_older_than_19_years_old: 'Turi būti ne vyresnis nei 19 metų',
    successfully_updated_child: 'Vaiko duomenys sėkmingai atnaujinti',
    successfully_invited_child: 'Vaikas sėkmingai pridėtas. Jam išsiutas pakvietimas el. paštu',
    resend_child_invite_success: 'Pakvietimas sėkmingai išsiųstas',
    resend_child_invite_failure: 'Nepavyko išsiųsti pakvietimo. Bandykite dar kartą',
    email: 'El. paštas',
    group_required_error: 'Pasirinkite grupę',
    start_date_required_error: 'Įveskite pradžios datą',
    end_date_required_error: 'Įveskite pabaigos datą',
    'event.new_event': 'Sukurti naują pamoką',
    'event.update': 'Atnaujinti pamoką',
    'event.create': 'Sukurti pamoką',
    'event.end_date_later_than_start_date': 'Pabaigos data turi būti vėlesnė nei pradžios data',
    successfully_created_event: 'Pamoka sėkmingai sukurta',
    successfully_updated_event: 'Pamoka sėkmingai atnaujinta',
    successfully_deleted_event: 'Pamoka sėkmingai ištrinta',
    failed_to_create_event: 'Nepavyko sukurti pamokos',
    failed_to_update_event: 'Nepavyko atnaujinti pamokos',
    failed_to_delete_event: 'Nepavyko ištrinti pamokos',
    // --------------- REWARDS ---------------
    space_odyssey: 'Kosmoso odisėja',
    date: 'Data',
    place: 'Vieta',
    points_for_questions: 'Klausimų uždavimas',
    points_for_attendance: 'Lankomumas ir punktualumas',
    points_for_ideas: 'Dalinimasis idėjomis ir indeliu',
    points_for_practices: 'Užduočių iššūkių užbaigimas',
    points_for_helping_others: 'Pagalba bendraklasiams',
    points_for_challenges: 'Išskirtiniai iššūkiai ― misijos',
    challenge_points: 'Iššūkio taškai ir informacija',
    extra_points: 'Papildomi taškai',
    rewards: 'Apdovanojimai',
    choose: 'Pasirink',
    reward: 'apdovanojimą',
    additional_comment: 'Pastabos',
    claim_reward: 'Išsiųsti užsakymą',
    cancel_claim_reward: 'Persigalvojau, nereikia',
    leaderboard: 'Lyderių lentelė',
    claimed: 'Užsakyta',
    view: 'Peržiūrėti',
    order: 'Užsakyti',
    to_unlock: 'iki atrakinimo',
    balance_sheet_and_rules: 'Balanso lentelė ir taisykės',
    failed_to_load_rewards: 'Nepavyko užkrauti apdovanojimų. Pabandykite perkrauti puslapį.',
    insufficient_points: 'Neturite pakankamai taškų šiam apdovanojimui gauti',
    reward_already_claimed: 'Šis apdovanojimas jau yra užsakytas',
    claimed_reward: 'Užsakytas apdovanojimas',
    points_deducted: 'Nuskaityti taškai',
    reward_ordered: 'Apdovanojimas užsakytas. Mūsų komanda su tavimi netrukus susisieks dėl pristatymo.',
    teacher_prizes: 'Prizai',
    all_prizes_overview_for_teachers: 'Visų Prizų Apžvalga',
    teacher_prizes_description:
        'Čia galite peržiūrėti visus prieinamus prizus, surūšiuotus pagal lygius. Tai padės jums suprasti, kokių apdovanojimų siekia mokiniai.',
    available_options: 'Prieinami Variantai',
    no_options_available: 'Šiam prizui nėra prieinamų variantų',
    quantity: 'Kiekis',
    category: 'Kategorija',
    description: 'Aprašymas',
    total: 'Iš viso',
    skipped: 'Praleido',
    in_a_row: 'iš eilės',
    balance: 'Likutis',
    diploma: 'Diplomas',
    certificate: 'Atestatas',
    diploma_content_coming_soon: 'Diplomo turinys bus prieinamas netrukus',
    feedback: 'Atsiliepimas',
    downloadPDF: 'Atsisiųsti PDF',
    no_feedback_available_for_the_selected_group: 'Atsiliepimo nėra mokiniui.',
    // --------------- Feedback ---------------
    student_feedback: 'Atsiliepimas apie mokinį',
    write_new_feedback: 'Rašyti Naują Atsiliepimą',
    edit_feedback: 'Redaguoti Atsiliepimą',
    feedback_required: 'Atsiliepimas yra privalomas',
    feedback_too_short: 'Atsiliepimas turi būti bent 10 simbolių',
    feedback_too_long: 'Atsiliepimas negali viršyti 1000 simbolių',
    write_feedback_placeholder: 'Parašykite savo atsiliepimą apie šį mokinį...',
    characters: 'simboliai',
    save_feedback: 'Išsaugoti Atsiliepimą',
    update_feedback: 'Atnaujinti Atsiliepimą',
    feedback_saved_successfully: 'Atsiliepimas sėkmingai išsaugotas',
    feedback_updated_successfully: 'Atsiliepimas sėkmingai atnaujintas',
    failed_to_save_feedback: 'Nepavyko išsaugoti atsiliepimo',
    failed_to_load_feedback: 'Nepavyko užkrauti atsiliepimo',
    feedback_history: 'Atsiliepimų Istorija',
    approved_by_admin: 'Patvirtinta Administratoriaus',
    pending_admin_approval: 'Laukia Administratoriaus Patvirtinimo',
    feedback_access_restricted: 'Tik administratoriai gali teikti atsiliepimus',
    loading_feedback: 'Kraunamas atsiliepimas...',
    no_feedback_create_first: 'Atsiliepimo dar nėra. Sukurkite pirmą atsiliepimą šiam mokiniui.',
    no_feedback_available: 'Atsiliepimo nėra mokiniui.',
    display_feedback_to_student_and_parent: 'Rodyti atsiliepimą mokiniui ir tėvams',
    visible_to_student: 'Matomas mokiniui',
    hidden_from_student: 'Paslėptas nuo mokinio',
    visible: 'Matomas',
    remaining: 'liko',
    choose_semester: 'Pasirinkite semestra',
    semester1: 'Pirmas semestras',
    semester2: 'Antras semestras',
    // --------------- Feedback Visibility ---------------
    feedback_already_visible: 'Atsiliepimas Jau Matomas',
    feedback_already_visible_warning:
        // eslint-disable-next-line max-len
        'Kitas atsiliepimas jau yra matomas mokiniui. Vienu metu gali būti matomas tik vienas atsiliepimas. Pirmiausia paslėpkite šiuo metu matomą atsiliepimą.',
    enable_feedback_visibility: 'Įjungti Atsiliepimo Matomumą',
    enable_feedback_visibility_confirmation: 'Ar tikrai norite, kad šis atsiliepimas būtų matomas mokiniui ir tėvams?',
    disable_feedback_visibility: 'Išjungti Atsiliepimo Matomumą',
    disable_feedback_visibility_confirmation: 'Ar tikrai norite paslėpti šį atsiliepimą nuo mokinio ir tėvų?',
    understood: 'Supratau',
    // --------------- Diploma Visibility ---------------
    enable_diploma_visibility: 'Įjungti Diplomo Matomumą',
    enable_diploma_visibility_confirmation:
        // eslint-disable-next-line max-len
        'Ar tikrai norite, kad diplomai būtų atsisiunčiami visiems šios grupės mokiniams? Tai leis mokiniams ir tėvams atsisiųsti jų diplomus.',
    disable_diploma_visibility: 'Išjungti Diplomo Matomumą',
    disable_diploma_visibility_confirmation:
        // eslint-disable-next-line max-len
        'Ar tikrai norite paslėpti diplomus nuo visų šios grupės mokinių? Tai neleistų mokiniams ir tėvams atsisiųsti diplomų.',
    diploma_visibility_enabled: 'Diplomo matomumas įjungtas',
    diploma_visibility_disabled: 'Diplomo matomumas išjungtas',
    diploma_available: 'Priskirti diplomus šiai grupei',
    feedback_available: 'Priskirti atsiliepimus šiai grupei',
    space_odyssey_availible: 'Priskirti kosmoso odisėją šiai grupei',
    // --------------- Stripe export ---------------
    from_date: 'Nuo',
    to_date: 'Iki',
    from_date_required: 'Pradžios data yra privaloma',
    to_date_required: 'Pabaigos data yra privaloma',
    to_date_after_from: 'Pabaigos data turi būti vėlesnė nei pradžios data',
    export_stripe_data: 'Eksportuoti Stripe duomenis',
    stripe_export_success: 'Stripe eksportas sėkmingai užbaigtas',
    stripe_export_failed: 'Stripe eksportas nepavyko',
    // --------------- Parent Feedback Access ---------------
    no_children_found: 'Vaikų nerasta',
    please_add_children_to_view_feedback: 'Prašome pridėti vaikų, kad galėtumėte peržiūrėti jų atsiliepimus',
    select_child_and_group: 'Prašome pasirinkti vaiką ir grupę, kad galėtumėte peržiūrėti atsiliepimus',
    // --------------- Parent Diploma Access ---------------
    please_add_children_to_view_diploma: 'Prašome pridėti vaikų, kad galėtumėte peržiūrėti jų diplomus',
    no_diploma_available: 'Diplomas neprieinamas',
    diplomas_not_available_for_group:
        'Šiuo metu nėra galimybės atsisiųsti diplomo. Primename, kad diplomai išduodami pabaigus mokslo metų kursą. ',
    loading_diploma_data: 'Kraunami diplomo duomenys...',
    error_loading_diploma_data: 'Klaida kraunant diplomo duomenis. Pabandykite dar kartą.',
    no_diploma_code_found: 'Šiam mokiniui šioje grupėje diplomo kodas nerastas.',
    no_permission_view_diploma: 'Neturite leidimo peržiūrėti šio diplomo.',
    missing_diploma_information: 'Trūksta grupės arba vartotojo informacijos.',
    diploma_not_available_download: 'Diplomas šiuo metu nėra prieinamas atsisiuntimui.',
    // --------------- Diplomo formos laukai ---------------
    diploma_information: 'Diplomo informacija',
    diploma_name: 'Kurso pavadinimas diplomui',
    diploma_name_helper: 'Kurso pavadinimas, kuris atsiras diplome',
    diploma_description: 'Kurso aprašymas diplomui',
    diploma_description_helper: 'Aprašymas, ką mokiniai išmoko šiame kurse',
    learning_hours: 'Mokymosi valandos',
    learning_hours_helper: 'Bendras mokymosi valandų skaičius šiam kursui',
    learning_hours_must_be_positive: 'Mokymosi valandos turi būti teigiamas skaičius',
    admin_password_change: 'Administratoriaus slaptažodžio keitimas',
    admin_password_change_hint:
        'Palikite tuščią, kad išlaikytumėte dabartinį slaptažodį. Tik administratoriai gali keisti kitų vartotojų slaptažodžius.',
    password_changed_successfully: 'Slaptažodis sėkmingai pakeistas',
};

export default lt;
